<template>
  <v-container
    id="extended-forms"
    fluid
    tag="section"
  >
    <validation-observer
      v-slot="{ handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(submitForm)">
        <v-row>
          <v-col cols="12">
            <base-material-card
              class="pa-6"
              color="success"
              icon="mdi-cash-register"
              :title="title"
            >
              <v-skeleton-loader
                class="mx-auto"
                max-width="300"
                type="card"
                :loading="loadingCashDesk"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|max:50"
                          name="cashDesk.name"
                        >
                          <v-text-field
                            v-model="cashDesk.name"
                            :error-messages="errors"
                            color="secondary"
                            :label="$t('fields.cashDesk.name')"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col
                    cols="12"
                    md="6"
                  >
                    <v-row
                      align="center"
                      dense
                    >
                      <v-col cols="10">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required"
                          name="cashDesk.currencyId"
                        >
                          <v-select
                            v-model="cashDesk.currencyId"
                            :items="currencies"
                            item-text="name"
                            item-value="id"
                            :label="$t('fields.cashDesk.currencyId')"
                            :error-messages="errors"
                            outlined
                          />
                        </validation-provider>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="pa-3 text-center">
                  <v-btn
                    color="warning"
                    default
                    @click="cancel"
                  >
                    {{ $t('cancel') }}
                  </v-btn>
                  <v-btn
                    color="success"
                    default
                    type="submit"
                  >
                    {{ $t("save") }}
                  </v-btn>
                </div>
              </v-skeleton-loader>
            </base-material-card>
          </v-col>
        </v-row>
      </form>
    </validation-observer>

    <cash-desk-itemList
      v-if="formAction=='modify'"
      :cash-desk-id="cashDesk.id"
    />

    <base-material-snackbar
      v-model="showSuccessAlert"
      :dismissible="false"
      type="success"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['timeout']: 1000
      }"
    >
      <span class="text-uppercase">{{ $t('success') }} :</span>
    </base-material-snackbar>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import cashDeskItemList from './CashDeskItemList'
  import { repositoryFactory } from '@/api/repositoryFactory'
  const cashDesksRespository = repositoryFactory.get('cashDesks')
  const parameterRespository = repositoryFactory.get('parameters')

  export default {
    inject: ['theme'],
    name: 'CashDeskCrud',
    components: { cashDeskItemList },
    $_veeValidate: {
      validator: 'new',
    },
    data: () => ({
      cashDesk: {

      },
      currencies: [],
      showErrorMessage: false,
      errorMessage: '',
      loadingCashDesk: false,
      showSuccessAlert: false,
      formAction: null,
    }),
    computed: {
      title () {
        return this.formAction === 'add' ? this.$t('add-cashDesk') : this.$t('modify-cashDesk')
      },
    },
    mounted () {
      var self = this
      self.formAction = this.$route.params.id === 'add' ? 'add' : 'modify'

      if (self.formAction !== 'add') {
        self.loadingCashDesk = true
        self.cashDesk.id = this.$route.params.id
        cashDesksRespository.getById(self.cashDesk.id).then(response => {
          self.loadingCashDesk = false
          self.cashDesk = Object.assign({}, response.data.data)
        }).catch(err => {
          self.loadingCashDesk = false
          alert(err)
        })
      }
      this.getCurrencies()
    },
    methods: {
      submitForm (scope) {
        var self = this
        var data = {
          data: this.cashDesk,
        }

        if (self.formAction !== 'add') {
          cashDesksRespository.updateCashDesk(data, this.cashDesk.id).then(response => {
            if (response.data.isValid) {
              self.showSuccessAlert = true
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        } else {
          cashDesksRespository.addCashDesk(data).then(response => {
            if (response.data.isValid) {
              self.cashDesk.id = response.data.data.id
              self.showSuccessAlert = true
              self.formAction = 'modify'
            } else {
              self.showErrorMessage = true
              self.errorMessage = response.data.errorMessages[0]
            }
          }).catch(err => {
            self.errorMessage = err
            self.showErrorMessage = true
          })
        }
      },
      getCurrencies () {
        var self = this
        parameterRespository.getCurrencies().then(response => {
          self.currencies = response.data.data
        }).catch(err => {
          alert(err)
        })
      },
      cancel () {
        this.$router.push({ name: 'cashDesks' })
      },
    },
  }
</script>
